import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type Metadata = Record<string, unknown>;

export interface SpinnerMessagesState {
  [id: number]: { message: string; metadata?: Metadata };
}

const initialState: SpinnerMessagesState = {};

type BasicSpinnerDefinition = { id: number; message: string; metadata?: Metadata };

export const spinnerMessagesSlice = createSlice({
  name: 'spinnerMessages',
  initialState,
  reducers: {
    spinnerMessageAdded: (state, action: PayloadAction<BasicSpinnerDefinition>) => {
      state[action.payload.id] = action.payload;
    },

    spinnerMessageRemoved: (state, action: PayloadAction<number>) => {
      delete state[action.payload];
    },
  },
});

export const spinnerMessages = spinnerMessagesSlice.reducer;

export interface StateWithSpinnerMessages {
  readonly spinnerMessages: SpinnerMessagesState;
}
